export const TILE_COMPONENTS_CLASS_NAMES = {
    TILE_MEDIA: 'rocco-tile-media',
    TILE_DESCRIPTION_BLOCK: 'rocco-tile-description-block',
};
